<template>
  <v-container id="productos" tag="section">
    <base-v-component heading="Productos del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          v-if="isAdmin"
          color="success"
          dark
          class="mb-2"
          @click="goAdd()"
          >{{ formTitle }}</v-btn
        >
        <v-btn
          v-if="isAdmin"
          small
          color="primary"
          dark
          class="mb-2 mx-1"
          @click="goPrecios(item)"
          >PRECIOS <v-icon class="ml-1" small>mdi-currency-eur</v-icon></v-btn
        >
        <v-btn
          v-if="isAdmin"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-1"
          @click="descargarTarifas()"
          >Descargar Tarifas
          <v-icon class="ml-1" small>mdi-currency-eur</v-icon></v-btn
        >
        <v-btn
          v-if="isAdmin"
          :disabled="!categoria"
          :loading="loadingTraducir"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-4"
          @click="traducirLoQueSeVe()"
          >Traducir lo que se ve
          <v-icon class="ml-1" small>mdi-google-translate</v-icon></v-btn
        >

        <v-btn
          :disabled="!categoria || categoria == 'modificadores'"
          v-if="!ordenando && isAdmin"
          small
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="ordenando && isAdmin"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = false"
          >Volver listado</v-btn
        >
        <v-spacer />
        <v-spacer />
        <v-select
          class="mt-4"
          :items="categorias"
          v-model="categoria"
          label="Categoria"
        ></v-select>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-dialog v-model="dialogMapeo">
        <v-card>
          <v-card-title>
            <span class="headline">Mapeo con Neo {{ productoMapeo }}</span>
          </v-card-title>
          <v-card-text>
            <v-toolbar flat color="white">
              <v-text-field
                v-model="searchNeo"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="getProductosNeo">
                <v-icon color="white">mdi-autorenew</v-icon>
              </v-btn>
              <v-btn color="success" @click="saveMapeo()">
                <v-icon color="white">mdi-floppy</v-icon>
              </v-btn>
            </v-toolbar>

            <v-data-table
              v-model="selectedNeo"
              item-key="Codigo"
              single-select
              :headers="headersNeo"
              :items="productosNeo"
              :loading="loadingNeo"
              :search="searchNeo"
              show-select
            ></v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- tabla negocios-->
      <v-data-table
        :headers="headersBossNegocio"
        :items="productos"
        :loading="loading"
        :search="search"
        v-if="!isAdmin"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="2"
            width="135px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
      </v-data-table>

      <v-data-table
        :headers="headers"
        :items="productos"
        :loading="loading"
        :items-per-page="100"
        :search="search"
        v-if="!ordenando && isAdmin"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="2"
            width="135px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-chip
              v-if="esCentralizadoMapeoNeo"
              outlined
              :color="getColor(item)"
              dark
              class="mr-2"
              @click="openDialogMapeando(item)"
            >
              <v-icon small>mdi-link</v-icon>
            </v-chip>
            <!-- <v-btn
							v-if="item.individualPedible"
							@click="goLotes(item)"
							class="px-2 ml-1"
							color="secondary"
							min-width="0"
							small
						>
							<v-icon small>mdi-home</v-icon>
						</v-btn> -->
            <v-badge
              :value="!!item.grupoModificador"
              bordered
              color="purple"
              overlap
              left
            >
              <v-btn
                @click="goEdit(item)"
                class="px-2 ml-1"
                color="grey"
                min-width="0"
                small
                depressed
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </v-badge>
            <v-btn
              @click="duplicar(item)"
              class="px-2 ml-1"
              color="success"
              min-width="0"
              small
            >
              <v-icon small>mdi-content-duplicate</v-icon>
            </v-btn>
            <v-btn
              @click="deleteItem(item)"
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
      <v-row v-else-if="isAdmin" align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenP">
              <div v-for="element in productosOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{
                    mostrarIdioma(element.nombre)
                  }}</v-list-item-content>
                  <v-list-item-action>{{ element.orden }}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>


<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { storage } from "@/firebase";
import { createSlug } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import XLSX from "xlsx";
const ExcelJS = require("exceljs");

export default {
  components: {
    draggable,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingTraducir: false,
      dialogMapeo: false,
      //search: "",
      id: null,
      ordenando: false,
      headersBossNegocio: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcionMostrar",
        },
        {
          sortable: false,
          text: "Categoría",
          value: "categoriaMostrar",
        },
      ],
      headers: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Descripción interna",
          value: "descripcionInterna",
        },
        {
          sortable: false,
          text: "Precio",
          value: "",
        },
        {
          sortable: false,
          text: "Categoría",
          value: "categoriaMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      itemMapeando: null,
      searchNeo: "",
      loadingNeo: false,
      loadingMapeo: false,
      selectedNeo: [],
      headersNeo: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
    };
  },
  computed: {
    search: {
      get() {
        return this.$store.state.productos.busqueda;
      },
      set(v) {
        this.$store.commit("productos/setBusqueda", v);
      },
    },
    formTitle() {
      return this.isEdit ? "Editar Producto" : "Nuevo Producto";
    },
    categoria: {
      get() {
        return this.$store.state.productos.categoriaFiltrar;
      },
      set(v) {
        this.$store.commit("productos/setCategoriaFiltrar", v);
      },
    },
    ...mapState({
      //productos : (state) => state.productos.productosArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      productosNeo: (state) => state.neo.productosNeo,
    }),
    ...mapGetters({
      esCentralizadoMapeoNeo: "app/esCentralizadoMapeoNeo",
      isAdmin: "auth/isAdmin",
      negocio: "app/negocioGestObj",
      productos: "productos/getProductosListado",
      categoriasSelect: "categorias/getCategoriasSelect",
    }),
    categorias() {
      return [
        {
          text: "Todos",
          value: null,
        },
        {
          text: "Productos",
          value: "productos",
        },
        {
          text: "Modificadores",
          value: "modificadores",
        },
        {
          text: "Menús",
          value: "menus",
        },
        ...this.categoriasSelect,
      ];
    },
    subtitle() {
      return "Listado de productos de " + this.negocio.nombre;
    },

    productoMapeo() {
      return this.itemMapeando ? mostrarIdioma(this.itemMapeando.nombre) : "";
    },
    productosOrden() {
      return this.productos.sort((a, b) =>
        a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
      );
    },
    ordenP: {
      get() {
        return this.productosOrden;
      },
      set(v) {
        var res = [];
        let _vm = this;
        v.forEach((e, i) => {
          let aux = {
            orden: i,
            id: e.id,
          };
          res.push(aux);
        });
        return this.$store
          .dispatch("productos/ordenarProductos", res)
          .then(() => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Productos ordenados",
            });
            _vm.getProductos();
          })
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al ordenar productos",
            });
          });
      },
    },
  },
  watch: {
    dialogMapeo(val) {
      val || this.close();
    },
  },
  methods: {
    async descargarTarifas() {
      const tarifas = this.$store.state.productos.tarifas;
      const imps = this.$store.state.impuestos.impuestosArray;
      const cats = this.$store.state.categorias.categoriasArray;
      const modificadores = this.$store.state.productos.modificadores;
      const gruposModificadores =
        this.$store.state.productos.gruposModificadores;

      let res = this.$store.state.productos.productosArray
        .filter((p) => !!p.individualPedible)
        .map((prd) => {
          let cFound = cats.find((c) => c.id == prd.categoria);
          let iFound = imps.find((c) => c.id == prd.impuesto);
          return {
            ...prd,
            categoriaNombre: cFound ? cFound.nombre : "Categoría sin definir",
            impuestoNombre: iFound ? iFound.nombre : "Impuesto sin definir",
            tarifas: Array.isArray(prd.tarifas)
              ? prd.tarifas.map((t) => {
                  let impTFound = imps.find((c) => c.id == t.impuesto);
                  let tarifaFound = tarifas.find((tar) => tar.id == t.id);
                  return {
                    ...t,
                    nombreTarifa: !!tarifaFound
                      ? tarifaFound.nombre
                      : "Tarifa sin definir",
                    impuestoNombre: impTFound
                      ? impTFound.nombre
                      : "Impuesto sin definir",
                  };
                })
              : [],
          };
        });

      //neuva librería

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "Mewosystems";
      workbook.lastModifiedBy = "Mewosystems";
      workbook.created = new Date();
      workbook.modified = new Date();
      workbook.lastPrinted = new Date();
      let agrupados = _.groupBy(res, "categoriaMostrar");
      console.log(agrupados);
      var cabeceraDinamicas = tarifas
        .map((t) => {
          return [
            {
              name: "Nombre tarifa",
              width: 25,
            },
            {
              name: "Activo",
              width: 15,
            },
            {
              name: "Impuesto",
              width: 10,
            },
            {
              name: "Precio",
              width: 10,
            },
          ];
        })
        .flat();
      console.log(cabeceraDinamicas);

      for (let cat in agrupados) {
        var sheet = workbook.addWorksheet(cat);

        let ws_data = [
          ...agrupados[cat].map((prd) => {
            return [
              prd.nombreMostrar,
              ...prd.tarifas
                .map((t) => {
                  return [t.nombreTarifa, t.activo, t.impuestoNombre, t.precio];
                })
                .flat(),
            ];
          }),
        ];
        sheet.columns = [{ width: 30 }, ...cabeceraDinamicas];
        sheet.addTable({
          name: cat,
          ref: "A1",
          headerRow: true,

          columns: [{ name: "Nombre", width: 45 }, ...cabeceraDinamicas],
          rows: ws_data,
        });
      }

      // const workbook = createAndFillWorkbook();
      let r = await workbook.xlsx.writeBuffer();
      console.log(r);
      var bytes = new Uint8Array(r); // pass your byte response to this constructor

      var blob = new Blob([bytes], { type: "application/xlsx" }); // change resultByte to bytes

      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "datos.xlsx";
      link.click();
      return;

      // write to a stream
      // await workbook.xlsx.write(stream);

      // write to a new buffer
      // const buffer = await workbook.xlsx.writeBuffer();

      return;

      // console.log(res);
      // var wb = XLSX.utils.book_new();
      // let agrupados = _.groupBy(res, "categoriaMostrar");
      // console.log(agrupados);
      // wb.Props = {
      //   Title: "TARIFAS",
      //   Subject: "Tarifas del sistema Funeats",
      //   Author: "Mewosystems",
      //   CreatedDate: new Date(),
      // };
      // for (let cat in agrupados) {
      //   wb.SheetNames.push(cat);
      //   let anchosDinamicosColumnas = [];
      //   let ws_data = [
      //     ["NOMBRE", "CATEGORIA"],
      //     ...agrupados[cat].map((prd) => {
      //       return [
      //         prd.nombreMostrar,
      //         prd.categoriaMostrar,
      //         ...prd.tarifas
      //           .map((t) => {
      //             anchosDinamicosColumnas = [
      //               ...anchosDinamicosColumnas,
      //               { wch: 25 },
      //               { wch: 15 },
      //               { wch: 10 },
      //               { wch: 10 },
      //             ];
      //             return [t.nombreTarifa, t.activo, t.impuestoNombre, t.precio];
      //           })
      //           .flat(),
      //       ];
      //     }),
      //   ];
      //   var ws = XLSX.utils.aoa_to_sheet(ws_data);
      //   var wscols = [{ wch: 25 }, { wch: 17 }, ...anchosDinamicosColumnas];

      //   ws["!cols"] = wscols;
      //   wb.Sheets[cat] = ws;
      // }

      // XLSX.writeFile(wb, "Tarifas.xlsx");
    },
    async traducirLoQueSeVe() {
      var i = 0;
      this.loadingTraducir = true;
      let productosTraducir = this.productos;
      // productosTraducir = this.productos.filter(
      //   (p) => p.nombre[1].text.length == 0
      // ); // para traducir lo que queda
      while (i < productosTraducir.length) {
        console.log(i);
        let traducir = productosTraducir
          .slice(i, i + 10)
          .map((prd) => {
            return [
              {
                id: prd.id,
                key: "nombre",
                texto: prd.nombre,
              },
              {
                id: prd.id,
                key: "descripcion",
                texto: prd.descripcion,
              },
            ];
          })
          .flat();
        await this.$store
          .dispatch("traducir", traducir)
          .then((r) => {
            console.log(_.groupBy(r, "id"));
            let agrupados = _.groupBy(r, "id");
            var promesas = [];
            for (let prop in agrupados) {
              let propDinamicas = {};
              agrupados[prop].forEach((p) => {
                propDinamicas[p.key] = p.texto;
              });
              console.log(agrupados);
              let objGuardar = {
                id: prop,
                ...propDinamicas,
              };
              console.log(objGuardar);
              promesas.push(
                this.$store
                  .dispatch("productos/addProducto", {
                    ...objGuardar,
                  })
                  .catch((e) => console.log(e))
              );
            }
            return Promise.all(promesas);
          })
          .finally(() => {
            console.log("primer fin");
          });
        console.log("contador");
        i = i + 10;
      }
      this.getProductos();
      this.loadingTraducir = false;
    },
    mostrarIdioma(str) {
      return mostrarIdioma(str);
    },
    reload() {
      this.getProductos();
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/almacen/productos/add";
      this.$router.push(str);
    },
    goEdit(item) {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/productos/edit/" + item.id;
      this.$router.push(str);
    },
    goPrecios(item) {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/productos/precios/";
      this.$router.push(str);
    },
    goLotes(item) {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/productos/lote/" + item.id;
      this.$router.push(str);
    },
    getProductos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("productos/getProductos").finally(() => {
        _vm.loading = false;
      });
    },
    initNegocio() {
      let negocio = this.$route.params.negocio;
      this.$store.commit("app/setNegocioGest", negocio, { root: true });
    },
    getProductosNeo() {
      let _vm = this;
      this.loadingNeo = true;
      this.$store
        .dispatch("negocios/getProductosNeo")
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Productos Neo cargados",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al conectar con Neo: " + error,
          });
        })
        .finally(() => {
          this.loadingNeo = false;
        });
    },
    close() {
      this.dialogMapeo = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    openDialogMapeando(item) {
      this.dialogMapeo = true;
      this.itemMapeando = item;
      this.searchNeo = mostrarIdioma(item.nombre);
      if (item.mapeoNeo) {
        let found = this.productosNeo.find((e) => e.Codigo == item.mapeoNeo);
        if (found) this.selectedNeo.push(found);
      }
    },
    reiniciarDatos() {
      this.itemMapeando = null;
      this.selectedNeo = [];
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el producto? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("productos/deleteProducto", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Producto eliminado",
            });
            _vm.getProductos();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    duplicar(item) {
      let r = confirm("¿Quieres duplicar el producto?");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("productos/duplicateProducto", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Producto duplicado",
            });
            _vm.getProductos();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al duplicar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    saveMapeo() {
      let m = this.selectedNeo[0];
      let _vm = this;
      let prd = {
        id: this.itemMapeando.id,
        mapeoNeo: m.Codigo,
      };
      this.loadingMapeo = true;
      return this.$store
        .dispatch("productos/saveMapeo", prd)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Mapeo correcto",
          });
          _vm.getProductos();
          _vm.close();
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al mapear: " + error,
          });
        })
        .finally(() => {
          this.loadingMapeo = false;
        });
    },
    getColor(item) {
      return item.mapeoNeo ? "green" : "red";
    },
  },
  mounted() {
    let _vm = this;
    //this.initNegocio();
    this.getProductos();
    // this.categoria = this.categorias[0].value;
  },
};
</script>

<style>
</style>